<template>
  <div id="step-1-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step1Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt: 'What is not a benefit of buying a home?',
          type: 'singleChoice',
          options: [
            'Building equity',
            'Value of the home may appreciate',
            'Possible tax incentives',
            'Short-term commitment',
          ],
          correctAnswer: 3,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'Building equity, potential for home appreciation and possible tax incentives are all benefits of buying a home. Buying a home is typically a long-term commitment as opposed to rent, which is usually a short-term commitment.',
        },
        {
          prompt: 'Your down payment could be as low as _% of the home price?',
          type: 'singleChoice',
          options: ['20%', '10%', '3%'],
          correctAnswer: 2,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'Depending on the mortgage options your lender has available and your risk profile, your down payment could be as low as 3% of the home price.',
        },
        {
          prompt: 'What does your credit score help lenders determine?',
          type: 'multipleChoice',
          options: [
            'Whether they will lend you the money',
            'The amount of money they will lend',
            'Your possible interest rate',
            'How much you need to save for a down payment',
          ],
          correctAnswer: [0, 1, 2],
          bottomHeaderTrue: 'Great!',
          bottomHeaderFalse: 'Not Quite.',
          bottomText:
            'Because a credit score can be an indicator of financial health, it’s used as a tool for lenders to determine if they’ll lend you the money, the amount of money they will lend, and the interest rate, but it does not impact how much your down payment should be.',
        },
      ],
    };
  },
};
</script>

<style>
</style>
